export default __webpack_public_path__ + "static/media/gteng02.f70c0f5a.png";